import { render, staticRenderFns } from "./inventory-bulk-update.vue?vue&type=template&id=bb49e27c&"
import script from "./inventory-bulk-update.vue?vue&type=script&lang=js&"
export * from "./inventory-bulk-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports